import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import { StyledLibraryLevelFilter } from './LibraryLevelFilter.styled';
import { Tag } from 'antd';
import Image from 'next/legacy/image';
import Colors from '@/constants/Colors';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { tagsWithAll } from '@/constants/Tags';
import useTagsFilter from '@/hooks/useTagsFilter.hook';
import { usePlausibleContext } from '@/shared/PlausibleAnalytics/PlausibleAnalytics';

export default function LibraryLevelFilter({
  className = '',
  size = 'default',
  fullText = 'Full library',
  currentTheme,
}) {
  const navigationContext = useContext(NavigationContext);
  const plausibleContext = usePlausibleContext();
  const { filterVisible, disabledTagIds } = useTagsFilter({
    currentTheme,
  });

  const sizeClass = `size-${size}`;

  return (
    <AnimatePresence>
      {filterVisible && (
        <motion.div
          style={{ height: 'auto' }}
          initial={{ height: 'auto' }}
          animate={{ height: 'auto' }}
          exit={{ height: 0 }}
        >
          <StyledLibraryLevelFilter className={`${className} ${sizeClass}`}>
            <div className="levels">
              {tagsWithAll.map((tag, idx) => {
                const { id, englishName, img, labels } = tag;
                const isAllTag = id == 'all';
                const selected = navigationContext.state.selectedTagId
                  ? navigationContext.state.selectedTagId == tag.id
                  : isAllTag;

                const disabled = disabledTagIds.includes(tag.id);

                return (
                  <div
                    className={`level card ${selected ? 'active' : ''} ${
                      disabled ? 'disabled' : ''
                    } ${isAllTag ? 'all' : ''}
                    `}
                    key={idx}
                    onClick={() => {
                      if (!disabled) {
                        navigationContext.actions.setSelectedTagId(
                          isAllTag ? null : tag.id
                        );
                        plausibleContext.actions.sendPlausibleEvent(
                          'button_click',
                          {
                            action: 'filter_level',
                            level: tag.englishName || 'all',
                          }
                        );
                      }
                    }}
                  >
                    <div className="card-header">
                      <div className="card-image">
                        {isAllTag ? (
                          <ActivityTypeIcon
                            className="icon"
                            type="themes"
                            size={20}
                            withCircle
                            color="white"
                            circleColor={Colors.purple}
                          />
                        ) : (
                          <Image src={img} layout="fill" alt="" />
                        )}
                      </div>
                      <div className="card-title">
                        {isAllTag ? fullText : englishName}
                      </div>
                    </div>
                    <div className="card-grades">
                      <span className="grade-text">Grades</span>
                      <span className="grades-list">
                        {labels.map((label) => (
                          <Tag key={label}>{label}</Tag>
                        ))}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </StyledLibraryLevelFilter>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
